import React from "react";
import "./ModalPopup.css"; // Import CSS for styling
import { useT } from "../i18n";

const ModalPopup = ({isOpen,closeModal,betData,session,gameName,handleSubmit,myBidsErrors}) => {
  const { t } = useT();
  return (
    <div>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2 style={{marginLeft:'34%'}}>{gameName.split('_').join(' ')}</h2>
              <button className="close-btn" onClick={closeModal}>
                &#x2715;
              </button>
            </div>
<div style={{overflowY:'auto',maxHeight:'300px'}}>
            {/* Table Section */}
            <table className="modal-table">
              <thead>
                <tr>
                  <th>{t('Digits')}</th>
                  <th>{t('Points')}</th>
                  <th>{t('Session')}</th>
                  <th>{t('Bid status')}</th>
                </tr>
              </thead>
              <tbody>
              {
                Object.keys(betData).map((key,index) => (

                    <tr>
                    <td>{key}</td>
                    <td>{betData[key]}</td>
                    <td>{t(session)}</td>
                    <td>{t(myBidsErrors[key]||'HOLD')}</td>
                  </tr>

                ))}
               
               
              </tbody>
            </table>
</div>
            <p className="note">*{t("Note: Bid once played will not be cancelled")}*</p>

            {/* Footer Section */}
            <div className="modal-footer">
              
              <div className="footer-buttons modal_button">
                <button className="continue-button" style={{color:'#007bff',backgroundColor:'white',boxShadow:'#ff000078 1px 1px 1px 1px'}} onClick={closeModal}>
                  {t('Cancel')}
                </button>
                <button className="continue-button" onClick={handleSubmit}>{t("Submit")}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalPopup;
